// token-refresh.service.ts
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/api/dynamic-form/services';

@Injectable({
  providedIn: 'root',
})
export class TokenRefreshService {
  constructor(private authService: AuthService) {}

  refreshToken(): Observable<any> {
    // Use only for making API call, not for handling headers
    return this.authService.refreshToken();
  }
}
